import {extend} from 'flarum/extend';
import Post from 'flarum/components/Post';
import PostStream from 'flarum/components/PostStream';

export default function () {
  // Remove "Slet" and "Afvis indberetning" from flagged posts
  extend(Post.prototype, 'flagActionItems', function (items) {
    items.items.controls.content.children = items.items.controls.content.children.filter(o => o.itemName !== 'hide');
    items.remove('dismiss');
  });

  /**
   * Show a flag if either:
   * - the discussion is hidden and/or,
   * - the user can't approve discussions and the discussion is not approved.
   * In case the user can approve discussions, she gets another flag for
   * approval.
   */
  extend(PostStream.prototype, 'view', function (vdom) {
    if (this.discussion.isHidden() || (!this.discussion.posts().find(d => d !== undefined).canApprove() && !this.discussion.isApproved())) {
      const flag = (
        m('div', {className: 'custom-post-flagged'}, [
          m('div', {className: 'custom-post-flagged-flags'}, [
            m('p', {}, app.translator.trans('flarum-flags.forum.flag_post.hidden_text'))
          ])
        ])
      );
      vdom.children.unshift(flag);
    }
  });
}
